import { ESearchResultsActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const changeSearchResultsUrl = actionGenerator<ESearchResultsActionType.UrlChanged, string>(
  ESearchResultsActionType.UrlChanged,
);
